<template>

<v-container class="fill-height black" fluid  >
    <div class="h5p-container" style="width: 99%; height: 99%; box-sizing: content-box" ref="h5p-preview"></div>
</v-container>

</template>

<script>




  import ShuttleMixins from '@/mixins/ShuttleMixins.js';
  export default {
    name: 'ShuttlePlay',
     mixins:[ShuttleMixins],
    props: {
      source: String,
    },
    data: () => ({
      question_dialog: false,
      drawer: false,
      items: [
        { icon: 'mdi-trending-up', text: 'Most Popular' },
        { icon: 'mdi-youtube-subscription', text: 'Subscriptions' },
        { icon: 'mdi-history', text: 'History' },
        { icon: 'mdi-playlist-play', text: 'Playlists' },
        { icon: 'mdi-clock', text: 'Watch Later' },
      ],
      items2: [
        { picture: 'p01.jpeg', text: 'Dr. Teresa Martin-Carreras', spk:0 },
        { picture: 'p02.jpeg', text: 'Dr. Sana Khalid',spk:1 },
        { picture: 'p03.jpeg', text: 'Dr. Vidur Mahajany',spk:2 },
        { picture: 'p04.jpeg', text: 'Dr. Irena Tocino', spk:3 }
      ],

        presentations: [
        { picture: 'pr01.png', text: 'Implimenting AI in the Clinical Practice', spk:1 },
        { picture: 'pr01.png', text: 'Examples of AI Deployment',spk:2 },
        { picture: 'pr01.png', text: 'Beyond ROC and ROI', spk:3 }
      ],

      questions:[
          { picture: 'p02.jpeg', question: 'How does Google or Microsoft plan their processes and procedures to support fast and efficient development of high quality products and get them out to a global marketplace?', timestamp:266 },
{ picture: 'p02.jpeg', question: 'How do we ensure that the resulting output off the AI algorithm is accurate?', timestamp:654 }
    ,{ picture: 'p04.jpeg', question: 'How do we choose algorithms?', timestamp:1981 }     
 




      ]


      





    }),
    created () {
      this.$vuetify.theme.dark = true;

        
        
        
    },

    mounted () {

      //this.loadTranscript();

      this.loadH5p();
       
    },

    methods:{

     loadH5p(){

 
      /*
        var vm = this;
        (function($) {
              $(function() {
                ////console.log(vm.default_context_json)
                $('.h5p-container').h5p({
                  frameJs: '/js/h5p-standalone-frame.js',
                  frameCss: '/styles/h5p.css',
                  h5pContent: '/h5p_packages/siim2',
                  libraryPath: vm.$store.state.uri.h5p_library,
                  //contentOverride: vm.$store.state.default_context_json,
                  //h5pOverride: vm.$store.state.uri.h5p_json_default
                });
              });
            })(H5P.jQuery);

    */


        var vm = this;
        (function($) {
              $(function() {
                ////console.log(vm.default_context_json)
                $('.h5p-container').h5p({
                  frameJs: '/js/h5p-standalone-frame.js',
                  frameCss: '/styles/h5p.css',
                  h5pContent: '/h5p_packages/' + this.$route.params.id,
                  libraryPath: vm.$store.state.uri.h5p_library,
                  //contentOverride: vm.$store.state.default_context_json,
                  //h5pOverride: vm.$store.state.uri.h5p_json_default
                });
              });
            })(H5P.jQuery);



      },


    loadTranscript(){

        
      this.$axios
      .get('/data/transcript.json')
      .then(response => (this.info = response))
          
      },


      loadPresenter(num){

        //console.log('PRESENTER ' + num);

        document.getElementsByClassName('h5p-iframe')[0].contentWindow.H5P.instances[0].seek(Object.keys(document.getElementsByClassName('h5p-iframe')[0].contentWindow.H5P.instances[0].bookmarksMap)[num]);
        document.getElementsByClassName('h5p-iframe')[0].contentWindow.H5P.instances[0].play();

      },

      videoSeek(num){

        //console.log('seek ' + num);

        document.getElementsByClassName('h5p-iframe')[0].contentWindow.H5P.instances[0].seek(num);
        document.getElementsByClassName('h5p-iframe')[0].contentWindow.H5P.instances[0].play();
        this.question_dialog = false;

      }



    }






  }






</script>
    <style>
        .*, ::before ::after {
            box-sizing: border-box;
            display: block;
        }
    </style>

